import { Box, styled, Theme } from '@mui/material';
import { GRID_CONTAINER_BORDER_WIDTH } from 'src/constants';

export const screenBorderWidth = 5;

const sectionBorderWidth = 2;
const editorScreenBorderWidth = 10;

const getScaledSize = (originalSize: number, scale = 1) => {
  return originalSize * scale;
};

const getBorderWidth = (
  type: 'screen' | 'section' | 'editor' | 'grid',
  scale: number,
) => {
  return type === 'screen'
    ? screenBorderWidth
    : type === 'editor'
    ? editorScreenBorderWidth
    : type === 'grid'
    ? GRID_CONTAINER_BORDER_WIDTH * scale
    : sectionBorderWidth;
};

const getBorderColor = (
  type: 'screen' | 'section' | 'editor' | 'grid',
  editable: boolean,
  isSelected: boolean,
  isHovered: boolean,
  theme: Theme,
) => {
  if (isSelected || (isHovered && editable)) {
    return theme.palette.primary.dark;
  }

  return type === 'screen'
    ? theme.palette.secondary.dark
    : type === 'editor'
    ? theme.palette.secondary.dark
    : type === 'grid'
    ? theme.palette.secondary.dark
    : theme.palette.primary.light;
};

export const AssemblyScreenContainer = styled(Box)(
  ({ theme, height, width, $selectable, $scale, $type, $isSelected }) => `
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  position: relative;
  box-sizing: content-box;
  width: ${getScaledSize(width, $scale)}px;
  height: ${getScaledSize(height, $scale)}px;
  
  cursor: ${$selectable ? 'pointer' : 'unset'};
  border: ${getBorderWidth($type, $scale)}px solid ${getBorderColor(
    $type,
    $selectable,
    $isSelected,
    false,
    theme,
  )};
  background-color: ${theme.palette.primary.lighter};

  &:hover {
    border: ${getBorderWidth($type, $scale)}px solid ${getBorderColor(
    $type,
    $selectable,
    $isSelected,
    true,
    theme,
  )};
  }
`,
);

export const AssemblyScreenEditIconContainer = styled(Box)(
  ({ theme }) => `
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;

  svg {
    height: 100%;
    width: 50%;

    fill: ${theme.palette.primary.lighter};
  }
`,
);
